import React from "react";
import { Modal, Button, Descriptions, Tag, Typography, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { ExternalLink, Clock, Bell, Edit, CheckCircle, FileText, Search, Folder, XCircle } from "lucide-react";
import moment from "moment";
import { formatFullControlInterno, formatFullDate, getTypeFullName, getStatusLabel } from "./calendarUtils";

const { Title, Text } = Typography;

const ItemDetailsModal = ({ visible, onCancel, item, zIndex }) => {
  if (!item) return null;

  const { Tipo, ControlInterno, Fecha, Hora1, Hora2, id, Verificador, Status, Monto } = item;

  const modalTitle = (
    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      {Tipo === "visita" && <Clock size={20} />}
      {Tipo === "solicitud" && <Bell size={20} />}
      {Tipo === "contrato" && <Edit size={20} />}
      {Tipo === "listo" && <CheckCircle size={20} />}
      {Tipo === "emision" && <FileText size={20} />}
      {(Tipo === "revision1" || Tipo === "revision2") && <Search size={20} />}
      {Tipo === "papeleria" && <Folder size={20} />}
      {Tipo === "cancelacion" && <XCircle size={20} />}
      <span style={{ fontSize: "18px", fontWeight: 600 }}>
        {getTypeFullName(Tipo)} - {formatFullControlInterno(ControlInterno)}
      </span>
    </div>
  );

  return (
    <Modal
      title={modalTitle}
      visible={visible}
      onCancel={onCancel}
      zIndex={zIndex}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cerrar
        </Button>,
        <Link key="view" to={`/verificaciones/${id}`}>
          <Button type="primary" icon={<ExternalLink size={16} />}>
            Ver Verificación
          </Button>
        </Link>,
      ]}
      width={600}
    >
      <div style={{ padding: "20px 0" }}>
        <Descriptions
          bordered
          column={1}
          size="middle"
          labelStyle={{ width: "30%", fontWeight: 600, backgroundColor: "#fafafa" }}
          contentStyle={{ backgroundColor: "#ffffff" }}
        >
          <Descriptions.Item label="Control Interno">
            <Text style={{ fontSize: "16px", fontWeight: 500 }}>{formatFullControlInterno(ControlInterno)}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Tipo de Actividad">
            <Tag
              color={
                Tipo === "visita"
                  ? "blue"
                  : Tipo === "solicitud"
                  ? "green"
                  : Tipo === "contrato"
                  ? "purple"
                  : Tipo === "listo"
                  ? "cyan"
                  : Tipo === "emision"
                  ? "gold"
                  : Tipo === "revision1"
                  ? "cyan"
                  : Tipo === "revision2"
                  ? "orange"
                  : Tipo === "papeleria"
                  ? "lime"
                  : "red"
              }
              style={{ fontSize: "14px", padding: "4px 12px" }}
            >
              {getTypeFullName(Tipo)}
            </Tag>
          </Descriptions.Item>

          <Descriptions.Item label="Status">
            <Text style={{ fontSize: "16px" }}>{getStatusLabel(Status)}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Monto">
            <Text style={{ fontSize: "16px" }}>{Monto}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Verificador">
            <Text style={{ fontSize: "16px" }}>{Verificador}</Text>
          </Descriptions.Item>

          <Descriptions.Item label="Fecha Programada">
            <Text style={{ fontSize: "16px" }}>{formatFullDate(Fecha)}</Text>
          </Descriptions.Item>

          {Tipo === "visita" && Hora1 && Hora2 && (
            <>
              <Descriptions.Item label="Hora de Inicio">
                <Text style={{ fontSize: "16px", fontWeight: 500, color: "#1890ff" }}>{moment(Hora1, "HH:mm").format("HH:mm")}</Text>
              </Descriptions.Item>

              <Descriptions.Item label="Hora de Término">
                <Text style={{ fontSize: "16px", fontWeight: 500, color: "#1890ff" }}>{moment(Hora2, "HH:mm").format("HH:mm")}</Text>
              </Descriptions.Item>

              <Descriptions.Item label="Duración">
                <Text style={{ fontSize: "16px" }}>{moment(Hora2, "HH:mm").diff(moment(Hora1, "HH:mm"), "minutes")} minutos</Text>
              </Descriptions.Item>
            </>
          )}
        </Descriptions>
      </div>
    </Modal>
  );
};

export default ItemDetailsModal;
